import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { INCIDENTS_COUNT_POLLING_ASYNC } from './constants'

const initialState = {
  incidentsCount: {
    openIncidents: 0,
    challengedIncidents: 0,
  },
  incidentsCountLoaded: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_FILTER_CHANGE:
    case INCIDENTS_COUNT_POLLING_ASYNC.INITIATE:
      if (state.error == null) return state
      return { ...state, error: null }
    case INCIDENTS_COUNT_POLLING_ASYNC.SUCCESS: {
      const { openIncidents, challengedIncidents } = action.payload.data
      if (
        state.incidentsCountLoaded &&
        openIncidents === state.incidentsCount.openIncidents &&
        challengedIncidents === state.incidentsCount.challengedIncidents
      )
        return state
      return {
        ...state,
        error: null,
        incidentsCount: action.payload.data,
        incidentsCountLoaded: true,
      }
    }
    case INCIDENTS_COUNT_POLLING_ASYNC.ERROR:
      return { ...state, error: action.error }
    default:
      return state
  }
}
